// @ts-check
import { wrapFormComponentWithLabelAndError } from './StyledFormComponentWrappers';
import OrganizationSelection from 'shared/components/OrganizationSelection';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const RawOrganizationSelection = wrapFormComponentWithLabelAndError(OrganizationSelection);
RawOrganizationSelection.displayName = 'RawOrganizationSelection';

const OrganizationSelectionField = connectFormComponentToReduxForm(RawOrganizationSelection);
OrganizationSelectionField.displayName = 'OrganizationSelectionField';

export default OrganizationSelectionField;

const OrganizationSelectionInput = connectFormComponentToReduxForm(
  wrapFormComponentWithLabelAndError(OrganizationSelection)
);

export { OrganizationSelectionInput };
